// Two-word display names, assigned by the server at join. Flavor rule:
// something a Cowboy Bebop episode title wouldn't be embarrassed by.

export const NAME_ADJECTIVES: readonly string[] = [
  "Amber",
  "Analog",
  "Ashen",
  "Brass",
  "Cobalt",
  "Copper",
  "Cosmic",
  "Crimson",
  "Drifting",
  "Dusty",
  "Electric",
  "Ember",
  "Feral",
  "Foggy",
  "Gentle",
  "Golden",
  "Hollow",
  "Howling",
  "Indigo",
  "Jaded",
  "Kinetic",
  "Lazy",
  "Lunar",
  "Mellow",
  "Midnight",
  "Neon",
  "Nimble",
  "Onyx",
  "Paper",
  "Quiet",
  "Radiant",
  "Rusty",
  "Sable",
  "Satin",
  "Smoky",
  "Solar",
  "Stray",
  "Tidal",
  "Umber",
  "Vagrant",
  "Velvet",
  "Wandering",
  "Weary",
  "Yonder",
];

export const NAME_NOUNS: readonly string[] = [
  "Anvil",
  "Bandit",
  "Comet",
  "Corsair",
  "Cricket",
  "Drifter",
  "Dynamo",
  "Falcon",
  "Gambler",
  "Harpoon",
  "Heron",
  "Ibis",
  "Jackal",
  "Kestrel",
  "Lantern",
  "Magpie",
  "Meteor",
  "Mongoose",
  "Nebula",
  "Nomad",
  "Otter",
  "Piston",
  "Quasar",
  "Rambler",
  "Rocket",
  "Sax",
  "Skiff",
  "Sparrow",
  "Swindler",
  "Tanager",
  "Trumpet",
  "Vagabond",
  "Walrus",
  "Zephyr",
];

/** e.g. "Velvet Mongoose". Pass a seeded rng for determinism in tests. */
export function generateName(rng: () => number = Math.random): string {
  const adjective = NAME_ADJECTIVES[Math.floor(rng() * NAME_ADJECTIVES.length)];
  const noun = NAME_NOUNS[Math.floor(rng() * NAME_NOUNS.length)];
  return `${adjective} ${noun}`;
}

/**
 * True if the name is one this generator could have produced. The server
 * uses this to decide whether a client's remembered name may be reused.
 */
export function isGeneratedName(name: unknown): name is string {
  if (typeof name !== "string") return false;
  const words = name.split(" ");
  if (words.length !== 2) return false;
  const [adjective, noun] = words;
  return NAME_ADJECTIVES.includes(adjective as string) && NAME_NOUNS.includes(noun as string);
}
